import tailwindClassnames from "../common/TailwindClassnames";
import { t } from "i18next";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";

type SearchBarLocationsProps = {
  countries: any[];
  onCountrySelection: Function;
  canAddLocation: boolean;
  openAddLocationModal: Function;
  onChangeSearchQuery: Function;
  onSearch: Function;
  tempLocationsSearchQuery: any;
  /**
   * Opens the CSV import (AKL-814). Supplied by the parent only when the user may create
   * locations — the same gate as "+ Add Location" — so the button renders on the prop alone.
   */
  onImportFromCsv?: () => void;
};

const SearchBarLocations = ({
  countries,
  onCountrySelection,
  canAddLocation,
  openAddLocationModal,
  onChangeSearchQuery,
  onSearch,
  tempLocationsSearchQuery,
  onImportFromCsv,
}: SearchBarLocationsProps) => {
  return (
    <div className={tailwindClassnames.tableCardToolbar}>
      <TextInput
        name={"location_name"}
        label={t("Name")}
        placeholder={t("Search location name")}
        value={tempLocationsSearchQuery.location_name || ""}
        error={""}
        disabled={false}
        className={tailwindClassnames.tableFilterInput}
        type={"text"}
        initialFocus={true}
        onChange={(e: any) => onChangeSearchQuery(e)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onSearch();
          }
        }}
      />
      <SelectInput
        options={countries.map((country) => ({
          value: country.code,
          label: country.name,
        }))}
        className={"w-44 text-left text-sm"}
        isDisabled={false}
        isLoading={false}
        isClearable={true}
        isSearchable={true}
        isMulti={false}
        name={t("Country")}
        onChange={(e: any) => onCountrySelection(e)}
        errors={""}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === "Enter") {
            onSearch();
          }
        }}
        searchBar={true}
      />
      <button
        className={tailwindClassnames.btnFilterApply}
        onClick={() => onSearch()}
      >
        {t("Apply filters")}
      </button>
      <div className="flex-1" />
      {onImportFromCsv && (
        <button
          type="button"
          onClick={onImportFromCsv}
          className={tailwindClassnames.btnSecondary}
          data-testid="import-locations-from-csv-toolbar"
        >
          {t("Import from CSV")}
        </button>
      )}
      {/* Conditional rendering, not a "hidden" class swap, so the gate
          can't be defeated by display utilities. */}
      {canAddLocation && (
        <button
          onClick={() => openAddLocationModal()}
          className={tailwindClassnames.btnPrimary}
        >
          <span aria-hidden="true">+ </span>
          {t("Add Location")}
        </button>
      )}
    </div>
  );
};

export default SearchBarLocations;
